import { Banner } from '@usealloy/component-library';
import styled from 'styled-components';


const MAX_NUMBER_OF_LIST_ITEMS = 5;

// NOTE: We want this container because if we apply a max-height to the ul itself
// then the bullet-points disappear; but, we can't apply it to the
// StyledListContainer because we have other elements that need to live inside
// of that and not scroll or be cut off by a max-height
export const ScrollboxContainer = styled.div`
  margin-bottom: 0.5rem;
  max-height: calc(var(--cl-font-size-5) * ${MAX_NUMBER_OF_LIST_ITEMS});
  overflow-y: scroll;
`;

export const StyledBanner = styled(Banner)`
  &&& {
    border-width: 2px;
    padding: var(--cl-space-5);

    & > div {
      align-items: flex-start;
    }
  }
`;

export const StyledList = styled.ul`
  list-style-type: disc;
  margin-left: var(--cl-space-5);
`;

export const StyledListContainer = styled.div`
  flex: 1;
  margin-top: -2px;
`;
